export const BorrowerChatTestIds = {
  BACK: 'borrower-chat.back-button',
};
